import { type FunctionComponent } from 'react';
import { PLACEHOLDER_OPTIONS } from '../../../constants/cloudinary/general';
import { ACCOUNT_PROJECTS_LINK, PROJECTS_LINK } from '../../../constants/links';
import { type CloudinaryOptions } from '../../../helpers/cloudinary-helper/cloudinary-helper';
import { useNavigation } from '../../../hooks/navigation/navigation.hooks';
import { type HomeProject } from '../../../types/home.types';
import { Link } from '../../common-components/link/link.component';
import { CloudinaryImage } from '../../images/cloudinary-image/cloudinary-image.component';
import { CreateProjectContent } from '../../project-components/create-project-content/create-project-content.component';
import ArrowRightAltIcon from '../../svgs/arrow-right-alt.svg';
import { projectsPanel, projectsModalContainer, sectionMaxHeight } from './projects.css';

export type HomepageProjectsProps = HomeProject & {
	automationHook: string;
};

export const Projects: FunctionComponent<HomepageProjectsProps> = ({ image, title, automationHook }) => {
	const navigate = useNavigation();
	const options: CloudinaryOptions = { crop: 'scale', width: 917, height: undefined };
	const onProjectCreated = (projectId: number) => {
		navigate(`${ACCOUNT_PROJECTS_LINK}/${projectId}/feed`);
	};

	return (
		<section
			className={`overflow-hidden-l relative-l flex-l tc bg-theme-primary-dark bg-theme-white-l ph2 ph0-l pb3 h-100 ${sectionMaxHeight}`}
			style={{ minHeight: 580 }}
			data-automation={automationHook}>
			<div className="dn db-l h-100">
				<CloudinaryImage
					options={options}
					publicID={image.id}
					description={image.description}
					placeholderOptions={{
						...options,
						...PLACEHOLDER_OPTIONS
					}}
				/>
			</div>
			<div
				className={`pb3 ph3 pv3-l ph5-l tc tl-l theme-white bg-theme-primary-dark-l absolute-l z-1 h-100-l w-auto-l right-0-l ${projectsPanel}`}>
				<h2 className="f2 lh-title mt0-l b ma0 mb3-l pt3 pt0-l">{title}</h2>
				<p className="theme-white f5 lh-title lh-copy-ns mv2 mb3-l tl-l mt0-l">
					Save favorite products, organize by room, and keep track of purchases.
				</p>
				<Link url={PROJECTS_LINK} color="white" className="b tc tl-l">
					<span>Learn More </span>
					<ArrowRightAltIcon className="v-mid" />
				</Link>
			</div>
			<div
				className={`flex flex-column justify-between bg-theme-white overflow-hidden ph2 pt1 pb5 pa3-l z-2 ${projectsModalContainer}`}>
				<div className="overflow-hidden-l">
					<div className="f3 tc normal lh-title pv3 pv0-l">Create a Project</div>
					<CreateProjectContent projectCreated={onProjectCreated} trackingPageName="homepage-create-project-modal" />
				</div>
			</div>
		</section>
	);
};
